import {lazy} from 'react';

// eslint-disable-next-line import-x/no-cycle
export const FormLazy = lazy(() => import(/* webpackChunkName: "form" */ '.'));
